const accordionSVG = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="9" viewBox="0 0 16 9" fill="none">
<path fill-rule="evenodd" clip-rule="evenodd" d="M0.299299 6.80244L6.80243 0.299306C7.20149 -0.0997591 7.84851 -0.0997591 8.24757 0.299306L14.7507 6.80244C15.1498 7.2015 15.1498 7.84851 14.7507 8.24758C14.3516 8.64664 13.7046 8.64664 13.3056 8.24758L7.525 2.46702L1.74444 8.24758C1.34537 8.64664 0.698363 8.64664 0.299299 8.24758C-0.0997662 7.84851 -0.0997662 7.2015 0.299299 6.80244Z" fill="#757575"/>
</svg>`
class SwatchPicker extends HTMLElement {
    constructor() {
        super();// always call super() first in the constructor.
        this.productId = this.getAttribute("data-product-id")
        this.optionPosition = this.getAttribute("data-option-position")
        this.optionName = this.getAttribute("data-option-name")
        this.optionSelected = this.nextElementSibling.querySelector('input:checked').value;
        this.upholstery = [];
        this.swatches = [];
        this.loader;
        this.selectedVariantId = this.getAttribute("data-selected-variant")
        this.selectedSwatchEl = this.querySelector(".swatch-picker--selected");
        this.availableOptionsEl = this.querySelector(".swatch-picker--available-options")
        this.changeBtn = document.querySelector(".swatch-picker--variant-change")
        this.variantsData = JSON.parse(this.closest('[data-product-blocks]')?.querySelector('[data-variant-json]')?.innerHTML)
        this.selectedVariant = this.variantsData.find(variant => variant.id == this.selectedVariantId)
    }

    connectedCallback() {
        // ...
        this.addEventListeners();
        this.retrieveUpholstery()
            .then(this.sanitizeResponseAndRender.bind(this))
    }

    addEventListeners() {
        this.changeBtn.addEventListener("click", this.openModal.bind(this))
        this.addEventListener("click", this.openModal.bind(this))
        document.addEventListener('swatch:confirm', this.handleSwatchChange.bind(this))
        document.addEventListener('variant:change', this.handleVariantChange.bind(this))
    }

    handleSwatchChange(event) {
        this.selectedSwatch = event.detail.swatch;
    }

    setLineItemProps() {
        const section = this.closest('.product-section');
        // A quote page has no purchase form. Do not write into a retail
        // form for another product elsewhere on the page.
        if (!section || section.dataset.purchasePolicy === 'quote') return;
        const swatchObj = this.swatches.find(swatch => swatch.id == this.selectedSwatch.id)
        const swatchName = swatchObj.name;
        const swatchGroup = swatchObj.swatch_group;
        const fabricGroup = swatchObj.fabric_group;
        const swatch = swatchObj.img_url || swatchObj.hex_code;
        section.querySelector('[name="properties[Swatch Name]"]').value = swatchName;
        section.querySelector('[name="properties[Swatch Group]"]').value = swatchGroup;
        section.querySelector('[name="properties[Fabric Group]"]').value = fabricGroup;
        section.querySelector('[name="properties[Swatch]"]').value = swatch;
    }

    handleVariantChange(event) {
        this.selectedVariant = event.detail.variant;
        this.optionSelected = this.nextElementSibling.querySelector('input:checked').value;
        this.updateView();
    }

    sanitizeResponseAndRender(response) {
        this.classList.remove("loading");
        this.upholstery = response.upholstery
        this.swatches = []
        this.upholstery.forEach((upholstery) => {
            upholstery.fabric_group?.swatch_group?.forEach((swatch_group) => {
                swatch_group.swatches.forEach((swatch) => {
                    this.swatches.push({
                        ...swatch,
                        swatch_group: swatch_group.name,
                        fabric_group: upholstery.fabric_group.name,
                        upholstery: upholstery.name,
                        upholsteryId: upholstery.id
                    })
                })
            })
        })
        this.updateView(true)
    }

    retrieveUpholstery() {
        return fetch(`https://swatch-maker-59874646a707.herokuapp.com/api/product/${this.productId}/storefront/`)
            .then(response => response.json())
        // Make API call and store the values
    }

    formatMoney(amount) {
        theme.Currency.formatMoney(amount, theme.settings.moneyFormat);
    }

    showLoader(boolean) {

    }

    updateView(firstLoad = false) {
        const selectedGroup = this.upholstery.find(option => option.name == this.optionSelected);
        const selectedFabricGroup = selectedGroup['fabric_group'];

        // check if selected upholstery option has fabric group else select option with fabric group
        if (!selectedFabricGroup) {
            const group = this.upholstery.find(group => {
                if (group.fabric_group?.swatch_group?.find(swatch => swatch.swatch_count)) return group
            })
            if (group) {
                document.querySelector(`input[value="${group.name}"]`).click();
                return false;
            } else {
                // if no group has swatches hide swatch picker and show default variant picker
                this.classList.add("hide");
                this.nextElementSibling.classList.remove("hide");
                document.querySelector(".variant__label-upholstery-option").classList.add("hide");
                document.querySelector(".swatch-picker--dash").classList.add("hide");
                this.closest('.product-section').querySelector(".upholstery-swatch-picker-line-properties")?.classList.remove("hide");
                return false;
            }
        }
        const selectedSwatchGroup = selectedFabricGroup['swatch_group'].find(swatchGroup => swatchGroup.name == this.selectedSwatch?.swatch_group_name) || selectedFabricGroup['swatch_group'].find(swatchGroup => swatchGroup.swatches.length > 0);
        this.selectedSwatch = this.selectedSwatch || selectedSwatchGroup['swatches'][0]

        if (firstLoad) {
            // read url params on load to update swatches once loading is complete
            const searchParams = new URLSearchParams(window.location.search);
            this.selectedSwatch = this.swatches.find(swatch => swatch.id == searchParams.get('swatch')) || this.selectedSwatch
        }
        this.updateSelectedSwatch();
        this.updateAvailableSwatches();
        if (this.selectedSwatch) {
            this.setLineItemProps();
        }

        // delaying to wait for theme.js variant change url update to complete
        setTimeout(() => {
            this.updateURL();
        })
    }

    updateURL() {
        const swatchObj = this.swatches.find(swatch => swatch.id == this.selectedSwatch.id)
        let searchParams = new URLSearchParams(window.location.search)
        const swatchSelected = {
            'variant': this.selectedVariant.id,
            'swatch': swatchObj.id
        }
        Object.keys(swatchSelected).forEach(option => {
            if (searchParams.has(option)) {
                searchParams.set(option, swatchSelected[option])
            } else {
                searchParams.append(option, swatchSelected[option])
            }
        })
        window.history.replaceState({ swatch: 'changed' }, '', window.location.pathname + '?' + searchParams.toString())
    }

    updateSelectedSwatch() {
        const swatchDiv = this.getSwatchEl(this.selectedSwatch);
        this.selectedSwatchEl.innerHTML = '';
        this.selectedSwatchEl.appendChild(swatchDiv);
        document.querySelector(".swatch-picker--variant-name").textContent = this.selectedSwatch.name;
    }

    getSwatchEl(swatchObject, selected = false, inputName = '', groupName = '', value = '') {
        let swatchDiv;
        if (swatchObject.img_url) {
            swatchDiv = document.createElement('span');
            let swatchImg = document.createElement('img');
            swatchImg.setAttribute('src', swatchObject.img_url)
            swatchDiv.appendChild(swatchImg)
        } else {
            swatchDiv = document.createElement('span');
            swatchDiv.style.backgroundColor = swatchObject.hex_code;
        }
        swatchDiv.classList.add("swatch-picker--swatch");

        let swatchTitle = document.createElement('span');
        swatchTitle.classList.add("swatch-picker--swatch-title");
        swatchTitle.textContent = swatchObject.name;

        let swatchWrapper = document.createElement('span');
        swatchWrapper.classList.add("swatch-picker--wrapper");

        swatchWrapper.appendChild(swatchDiv);
        swatchWrapper.appendChild(swatchTitle);
        if (inputName != '') {
            let swatchContainer = document.createElement('div')
            let input = document.createElement('input');
            input.type = "radio"
            input.setAttribute('name', inputName)
            input.setAttribute('id', inputName + '-' + groupName + '-' + value)
            input.setAttribute("value", value)
            input.classList.add("swatch-picker--swatch-input")
            if (selected) input.setAttribute("checked", "checked")
            let label = document.createElement('label')
            label.setAttribute('for', inputName + '-' + groupName + '-' + value)
            label.appendChild(swatchWrapper);
            swatchContainer.appendChild(input)
            swatchContainer.appendChild(label)
            return swatchContainer
        } else {
            return swatchWrapper;
        }
    }

    updateAvailableSwatches() {
        const availableSwatches = this.swatches;
        let swatchCount = 0;
        const availableSwatchesEl = this.querySelector(".swatch-picker--available-options-swatches");
        availableSwatchesEl.innerHTML = '';
        if (this.swatches.length > 1) {
            const availableText = this.querySelector(".swatch-picker--available-options-text");
            for (let count = 0; count < availableSwatches.length && swatchCount < 3; count++) {
                if (availableSwatches[count].id != this.selectedSwatch.id) {
                    swatchCount++
                    const swatchDiv = this.getSwatchEl(availableSwatches[count])
                    availableSwatchesEl.appendChild(swatchDiv)
                }
            }
            availableText.textContent = `${this.swatches.length - swatchCount - 1 ? '+' + (this.swatches.length - swatchCount - 1).toString() + ' more' : 'more'}`
        } else {
            this.availableOptionsEl.classList.add("hide")
        }
    }

    getGroupDiv(groupObject) {
        let _this = this
        let availableVariants = this.variantsData.filter(function (el) {
            if (!_this.selectedVariant) {
                return false;
            }

            if (_this.selectedVariant.option2 === el.option2 && _this.selectedVariant.option3 === el.option3) {
                return true;
            }

            if (_this.selectedVariant.option1 === el.option1 && _this.selectedVariant.option3 === el.option3) {
                return true;
            }

            if (_this.selectedVariant.option1 === el.option1 && _this.selectedVariant.option2 === el.option2) {
                return true;
            }
        });
        const optionAvailable = availableVariants.find(variant => variant.options.includes(groupObject.name));
        let fabricGroup = groupObject['fabric_group'];
        let groupName = groupObject.name;
        let groupDiv = document.createElement('swatch-group');
        groupDiv.setAttribute("data-option-name", groupName);
        groupDiv.setAttribute("data-accordion", "open");
        if (!optionAvailable) {
            groupDiv.setAttribute("data-accordion", "close");
            groupDiv.setAttribute("data-options", "disabled");
        }
        let html = ``;
        html += `<div class="fabric-group-title"><span>${fabricGroup.name}</span>${accordionSVG}</div>`;
        fabricGroup['swatch_group'].forEach((swatchGroup) => {
            if (swatchGroup['swatches'].length > 0) {
                html += `<div class="swatch-group-wrapper" data-swatch-group="${swatchGroup.id}">
                        <div class="swatch-group-title">${swatchGroup.name}</div>`
                html += swatchGroup.description ? `<div class="swatch-group-description">${swatchGroup.description}</div>` : ``;
                html += `<div class="swatch-group-swatches-wrapper">`

                swatchGroup['swatches'].forEach(swatch => {
                    html += this.getSwatchEl(swatch, groupName == this.optionSelected && swatch.id == this.selectedSwatch.id, 'swatch-picker', groupObject.id + '-' + swatchGroup.id + '-' + swatch.id, swatch.name).innerHTML;
                })

                html +=
                    `</div>
                        </div>`
            }
        })
        groupDiv.innerHTML = html;
        return groupDiv;
    }

    getModalSelectedSwach(swatchObj, variantObj) {
        let modalSelectedSwatch = document.createElement('swatch-modal-selected');
        modalSelectedSwatch.upholstery = this;
        modalSelectedSwatch.classList.add("swatch-picker--modal-selected")
        modalSelectedSwatch.appendChild(this.getSwatchEl(swatchObj || this.selectedSwatch));
        if (this.closest('.product-section') && this.closest('.product-section').dataset.purchasePolicy !== 'quote') {
            const price = variantObj?.price || this.getAttribute("data-upholstery-price");
            modalSelectedSwatch.innerHTML += `<div class="swatch-picker--modal-selected-price">Price: <span>${theme.Currency.formatMoney(price)}</span></div>`;
        }
        modalSelectedSwatch.innerHTML += `<div class="swatch-picker--modal-selected-continue-wrapper"><div class="swatch-picker--modal-selected-continue">Continue</div></div>`;
        return modalSelectedSwatch;
    }

    openModal(event) {
        if (event.target.classList.contains("swatch-picker--variant-change") || event.target.classList.contains("swatch-picker--available-options-text")) {
            document.querySelector('swatch-picker-modal').render(this.getModalContents());
            document.querySelector('swatch-picker-modal').openModal();
        }
    }

    closeModal() {
        document.querySelector('swatch-picker-modal').closeModal();
    }

    getModalContents() {
        let modalContents = document.createElement('swatch-modal-content');
        modalContents.classList.add("swatch-picker--modal-content");
        modalContents.innerHTML = `<div class="swatch-picker--modal-close">
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
            <path d="M21.5 2.61646L19.385 0.501465L11 8.88647L2.615 0.501465L0.5 2.61646L8.885 11.0015L0.5 19.3865L2.615 21.5015L11 13.1165L19.385 21.5015L21.5 19.3865L13.115 11.0015L21.5 2.61646Z" fill="black"/>
            </svg>
        </div>`
        let groupsWarpper = document.createElement('div')
        groupsWarpper.classList.add("swatch-picker--modal-content-group-wrapper");
        this.upholstery.forEach(fabricGroup => {
            if (fabricGroup.fabric_group?.['swatch_group'].length > 0) groupsWarpper.appendChild(this.getGroupDiv(fabricGroup))
        })
        modalContents.appendChild(this.getModalSelectedSwach())
        modalContents.appendChild(groupsWarpper);
        return modalContents;
    }
}

customElements.define('upholstery-swatch-picker', SwatchPicker);

class SwatchPickerModal extends HTMLElement {
    constructor() {
        super();// always call super() first in the constructor.
        this.overlay = this.querySelector(".swatch-picker--modal-overlay");
    }

    connectedCallback() {
        this.addEventListeners();
        this.escapeListener = this.checkForEscape.bind(this)
        this.pushModalLast();
    }
    pushModalLast() {
        if (this.nextElementSibling) {
            document.body.appendChild(this)
        }
    }

    addEventListeners() {
        document.addEventListener("swatchModal:close", this.closeModal.bind(this))
        this.overlay.addEventListener("click", this.closeModal.bind(this))
    }

    openModal() {
        this.pushModalLast();
        this.classList.remove('hide');
        setTimeout(() => {
            this.querySelector("swatch-modal-content").classList.add("animate");
        });
        document.body.classList.add('no-scroll');
        document.addEventListener("keydown", this.escapeListener);
    }

    checkForEscape(event) {
        if (event.key === "Escape") {
            this.closeModal();
        }
    }

    closeModal() {
        this.querySelector("swatch-modal-content").classList.remove("animate");
        setTimeout(() => {
            this.classList.add('hide')
            document.body.classList.remove('no-scroll');
            document.removeEventListener("keydown", this.escapeListener);
            this.contentEl?.remove();
        }, 100);
    }

    render(element) {
        this.prepend(element);
        this.contentEl = this.querySelector(".swatch-picker--modal-content");
    }
}
customElements.define('swatch-picker-modal', SwatchPickerModal);

class SwatchModalSelected extends HTMLElement {
    constructor() {
        super(); // always call super() first in the constructor.
        this.upholstery = document.querySelector('upholstery-swatch-picker')
        this.newVariant;
        this.swatchChangeDetail;
        this.swatchChange = this.handleSwatchChange.bind(this);
    }
    connectedCallback() {
        this.priceEl = this.querySelector(".swatch-picker--modal-selected-price span")
        this.continueBtn = this.querySelector(".swatch-picker--modal-selected-continue");
        this.continueBtn.addEventListener("click", this.confirmSwatchChange.bind(this))
        this.addEventListeners();
    }

    addEventListeners() {
        document.addEventListener('swatch:change', this.swatchChange);
        this.addEventListener('click', this.confirmSwatchChange.bind(this))
    }

    disconnectedCallback() {
        document.removeEventListener('swatch:change', this.swatchChange)
    }

    confirmSwatchChange(event) {
        if (event.target.classList.contains("swatch-picker--modal-selected-continue")) {
            document.dispatchEvent(new CustomEvent("swatchModal:close"))
            const selectedVariantObj = this.swatchChangeDetail?.variant;
            if (!selectedVariantObj) return;
            const options = selectedVariantObj.options
            options.forEach(option => document.querySelector(`fieldset input[value="${option}"]`).checked = true)
            document.dispatchEvent(new CustomEvent('swatch:confirm', {
                detail: {
                    variant: this.swatchChangeDetail.variant,
                    swatch: this.swatchChangeDetail.swatch
                }
            }))
            document.querySelector(`fieldset input[value="${options[0]}"]`).dispatchEvent(new Event('change'));
        }
    }

    handleSwatchChange() {
        this.swatchChangeDetail = event.detail;
        this.renderSelected(this.swatchChangeDetail.swatch, this.swatchChangeDetail.variant)
    }

    renderSelected(swatchObj, selectedVariantObj) {
        this.innerHTML = this.upholstery.getModalSelectedSwach(swatchObj, selectedVariantObj).innerHTML;
    }
}
customElements.define('swatch-modal-selected', SwatchModalSelected);


class SwatchModalContent extends HTMLElement {
    constructor() {
        super(); // always call super() first in the constructor.
    }

    connectedCallback() {
        this.closeBtn = this.querySelector(".swatch-picker--modal-close");
        this.closeBtn.addEventListener("click", () => {
            document.dispatchEvent(new CustomEvent("swatchModal:close"))
        })
        this.querySelectorAll('input[name="swatch-picker"]').forEach(swatch => {
            swatch.addEventListener('change', this.handleSwatchChange)
        })
    }

    handleSwatchChange() {
        const option = this.closest('swatch-group').getAttribute("data-option-name");
        const otherOptions = Array.from(document.querySelectorAll('[data-product-blocks] fieldset:not([name="Upholstery"]) input:checked')).map(input => input.value)
        const newOptions = [option, ...otherOptions].sort();
        const variantsObject = JSON.parse(document.querySelector('[data-variant-json]').innerHTML)
        const selectedVariantObj = variantsObject.filter(variant => {
            return JSON.stringify([...variant.options.sort()]) == JSON.stringify(newOptions)
        })[0]
        const swatchGroup = this.closest(".swatch-group-wrapper").getAttribute("data-swatch-group");
        const group = document.querySelector('upholstery-swatch-picker').upholstery.find(g => {
            return g.name == option
        })
        const swatchObj = group.fabric_group.swatch_group.find(sg => sg.id == swatchGroup).swatches.find(s => {
            return s.name == this.value
        })
        document.dispatchEvent(new CustomEvent('swatch:change', {
            detail: {
                variant: selectedVariantObj,
                swatch: swatchObj
            }
        }))
    }
}
customElements.define('swatch-modal-content', SwatchModalContent);
class SwatchGroup extends HTMLElement {
    constructor() {
        super(); // always call super() first in the constructor.
    }
    connectedCallback() {
        this.accordionState = this.dataset.accordion;
        this.options = this.dataset.options;
        this.querySelector('.fabric-group-title').addEventListener("click", this.accordionClick.bind(this))
        // handling continue button z-index bug on iOS safari
        if (this.querySelector('input[name="swatch-picker"]:checked')) {
            const selected = this.querySelector('input[name="swatch-picker"]:checked')
            setTimeout(() => {
                this.closest(".swatch-picker--modal-content-group-wrapper").querySelector('input[name="swatch-picker"]:not(:checked)').click()
                selected.click()
            }, 50);
        }
        if (this.options == "disabled") {
            this.querySelectorAll(".swatch-picker--swatch-input").forEach(input => input.setAttribute("disabled", "disabled"))
        }
    }

    accordionClick() {
        this.accordionState = this.accordionState == "open" ? "close" : "open"
        this.setAttribute("data-accordion", this.accordionState)
    }
}
customElements.define('swatch-group', SwatchGroup);
